export default class RemovedLeaguesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.leagues === undefined) {
            return;
        }

        const leagues = content.leagues.remove;

        if (leagues !== undefined) {
            for (let i = 0; i < leagues.length; i++) {
                leagues[i] = this._modelKeyRepository.removeLeague(leagues[i]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/RemovedLeaguesModifier.js